<template>
  <div v-if="shouldRenderConfig" :class="getClassName">
    <button
      type="button"
      class="btn btn-primary"
      :class="activeClass()"
      @click="setActiveProductPartName(code)"
    >
      {{ name }}
    </button>
  </div>
</template>
<script>
import { useWebproductStore } from "@/stores/modules/webproduct";
import { mapState, mapActions } from "pinia";

export default {
  computed: {
    ...mapState(useWebproductStore, ["getActiveProductPartName"]),
    code: function () {
      return this.propsData.code;
    },
    name: function () {
      return this.propsData.label;
    }
  },

  methods: {
    ...mapActions(useWebproductStore, ["setActiveProductPartName"]),
    activeClass: function () {
      return this.getActiveProductPartName == this.propsData.label
        ? "active"
        : "";
    }
  },

  props: ["propsData"]
};
</script>
